<template>
  <div class="mt-2 mt-md-0" :class="{ 'chips-col': !disabled }">
    <div class="chips-container">
      <div v-for="(item, index) in items" :key="index" class="chip">
        <span>
          <span class="chip-field font-weight-bold">
            {{ item.name }}
          </span>
        </span>
        <a v-if="!disabled" class="pointer" @click.prevent="remove(item)">
          <em class="far fa-lg fa-times-circle chip-close-icon" />
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ChipsSelection',
  meta: {
    description: 'Componente para entrada de selecciones multi-nivel.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  model: {
    prop: 'selectedItems',
    event: 'selectionChanged',
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    remove(item) {
      this.$emit('remove', item);
    },
  },
};
</script>

<style scoped>
.chip {
  border: 1px solid #b7c4bd;
  border-radius: 30px;
  display: inline-block;
  padding: 10px;
  margin: 0 0.5rem 0.5rem 0.5rem;
}

.chip-label {
  font: 1rem 'Lato';
  letter-spacing: 0;
  color: #727272;
  font-weight: normal;
}

.chip-field {
  margin-right: 1rem;
  margin-left: 0.25rem;
}

.chip-close-icon {
  color: red;
  vertical-align: -2px;
}

.pointer {
  cursor: pointer;
}

@media only screen and (max-width: 768px) {
  .chips-col {
    border-left: unset;
  }
}
</style>
